import { render, staticRenderFns } from "./lectureSignUp.vue?vue&type=template&id=2f16b24d&scoped=true&"
import script from "./lectureSignUp.vue?vue&type=script&lang=js&"
export * from "./lectureSignUp.vue?vue&type=script&lang=js&"
import style0 from "./lectureSignUp.vue?vue&type=style&index=0&id=2f16b24d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f16b24d",
  null
  
)

export default component.exports